// libs
import React from 'react';

// components
import Image from 'shared/components/ImageV2/index';

//types
import { Theme } from '@nykaa/ui-components/themes/types';

//hook
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

// constant
const COUPON_ERROR_IMAGE_WIDTH = 198;
const COUPON_ERROR_IMAGE_ASPECT_RATIO = 1;

// styles
import {
  CouponErrorContainer,
  Container,
  ImageContainer,
  Content,
  Title,
  Subtitle,
  ActionButton,
} from './styles';

interface CouponErrorPageProps {
  title: string;
  subtitle: string;
  imageUrl: string;
  actionName: string;
  onActionButtonClick: () => void;
  className?: string;
}

function CouponErrorPage({
  title,
  subtitle,
  imageUrl,
  actionName,
  onActionButtonClick,
  className,
}: CouponErrorPageProps) {
  const theme: Theme = useTheme();

  return (
    <CouponErrorContainer className={className}>
      <Container>
        <ImageContainer>
          <Image
            src={imageUrl}
            width={COUPON_ERROR_IMAGE_WIDTH}
            aspectRatio={COUPON_ERROR_IMAGE_ASPECT_RATIO}
            alt={actionName}
            placeholderColor={theme.colors.snow100}
          />
        </ImageContainer>
        <Content>
          <Title className="coupon-error-title">{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </Content>
        <ActionButton onClick={onActionButtonClick}>{actionName}</ActionButton>
      </Container>
    </CouponErrorContainer>
  );
}

export default CouponErrorPage;
